import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useId, useState } from 'react';
import { useSelector } from 'react-redux';
import setToast from '../../../helpers/toaster.helper';
import { DeleteChatIcon, IntegrationBlueIcon, IntegrationGridEmptyIcon } from '../../../icon';
import { IntegrateChannelsData, mapToIntegrateChannelsData } from '../../../models/channel.teams';
import { PhoneNumberModel, PhoneNumberStatus } from '../../../models/phone-number.model';
import * as selector from '../../../selectors/selectors';
import { IntegrationSetupService } from '../../../services/IntegrationSetup';
import { UserService } from '../../../services/UserService';
import ButtonComponent from '../../shared/button/button.component';
import { buttonLabels, } from '../../shared/constants';
import { ToasterType } from '../../shared/toaster/toaster.model';

interface IProps {
    organizationId: string;
    IsAdminConcentSucess: boolean;
}

const IntegrateChannels = (props: IProps) => {
    const uniqId = useId();
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);

    const [phoneNumberOptions, setPhoneNumberOptions] = useState<any[]>([]);
    const [data, setData] = useState<IntegrateChannelsData[]>([])
    const [teamOptions, setTeamOptions] = useState<any[]>([]);
    const [channelOptions, setChannelOptions] = useState<any[]>([]);

    // const [accessToken, setAccessToken] = useState<string | null>("");
    // const [team, setTeam] = useState<IntegrateChannelOptions>({ id: "", label: "" });
    // const [channel, setChannel] = useState<IntegrateChannelOptions>({ id: "", label: "" });
    // const [phoneNumber, setPhoneNumber] = useState<IntegrateChannelOptions>({ id: "", label: "" });
    // const [addNewChannel, setAddNewChannel] = useState<IntegrateChannelsData>({
    //     Id: uuidv4(),
    //     ChannelId: "",
    //     ChannelName: "",
    //     PhoneNumber: "",
    //     PhoneNumberId: "",
    //     TeamGuid: "",
    //     TeamName: "",
    //     provider: "",
    //     OrgId: "",
    //     OrgRef: "",
    //     UserId: "",
    //     ConversationRef: "",
    //     UserName: "",
    //     isEdit: false
    // });

    // const getAccessToken = async () => {
    //     const tokenEndpoint = `${Config.AUTH_URL}/api/SSOAuth/MSTokenRequest`;
    //     const tokenResponse = await axios.get(tokenEndpoint);
    //     setAccessToken(tokenResponse.data.access_token);
    // };

    // useEffect(() => {
    //     if (!accessToken)
    //         getAccessToken().catch(error => console.error('Error getting access token:', error));
    // }, []);

    // const getChannelTeam = async () => {
    //     const graphApiEndpoint = `https://graph.microsoft.com/v1.0/teams?$select=id,displayName,description`;
    //     const response = await axios.get(graphApiEndpoint, {
    //         headers: {
    //             Authorization: `Bearer ${accessToken.trim()}`,
    //         }
    //     });
    //     if (!!response.data.value)
    //         setTeamOptions(response.data.value.map(mapToIntegrateChannelOptions));
    // };

    // const getChannels = async (id: string) => {
    //     const graphApiEndpoint = `https://graph.microsoft.com/v1.0/teams/${id}/channels?$select=id,displayName,description`;
    //     const response = await axios.get(graphApiEndpoint, {
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`,
    //         },
    //     });
    //     if (!!response.data.value)
    //         setChannelOptions(response.data.value.map(mapToIntegrateChannelOptions));
    // };

    // useEffect(() => {
    //     if (!!accessToken) {
    //         getChannelTeam().catch(error => console.error('Error fetching team info:', error));
    //     }
    // }, [accessToken])

    // useEffect(() => {
    //     if (!!team.id) {
    //         getChannels(team.id);
    //     }
    // }, [team.id])

    const onClickLinkChannel = (rowdata: IntegrateChannelsData) => {
        const payload = {
            phoneNumber: rowdata.PhoneNumber,
            userName: `${rowdata.TeamName}-${rowdata.ChannelName}`,
            userId: UserService.getCurrentUserId(),
            channelId: rowdata.ChannelId,
            teamGUID: rowdata.TeamGuid,
            teamName: rowdata.TeamName,
            orgId: UserService.getCurrentUserOrgId(),
            orgRef: UserService.getCurrentUserOrgRef(),
            phoneNumberId: rowdata.PhoneNumberId,
            provider: 'Bandwidth'
        }

        IntegrationSetupService.updateIntegratedChannelDetails(payload)
            .then(res => {
                let updatedData = data.map((x: IntegrateChannelsData) => x.Id === rowdata.Id ? { ...x, Status: true } : x)
                setData(updatedData)
                setToast("Channel integrated sucessFully", ToasterType.SUCCESS)
            })
            .catch(err => {
                setToast("Channel integration failed", ToasterType.DANGER)
            })
    }

    const getIntegratedChannelsData = () => {
        IntegrationSetupService.getIntegratedChannelDetails(props.organizationId).then(res => {
            if (res.data !== null) {
                setData(res.data.map(mapToIntegrateChannelsData))
            }
            else {
                setData([])
            }
        })
    }

    useEffect(() => {
        if (!!props.organizationId && props.IsAdminConcentSucess)
            getIntegratedChannelsData()
    }, [props.organizationId, props.IsAdminConcentSucess]);



    useEffect(() => {
        if (PhoneNumbers.length > 0)
            setPhoneNumberOptions(PhoneNumbers.filter(x => x.Status === PhoneNumberStatus.ACTIVE).map(y => ({
                label: y.PhoneNumber,
                id: y.ID
            })));
    }, [PhoneNumbers]);

    const onClickDelete = (id) => {
        IntegrationSetupService.deleteIntegratedChannel(id).then(res => {
            setToast("Channel deleted sucessFully", ToasterType.SUCCESS)
            getIntegratedChannelsData();
        }
        ).catch(err =>
            setToast("Channel deletion failed", ToasterType.DANGER)
        )
    }

    const onClickTestIntegration = (id) => {
        IntegrationSetupService.testChannelIntegration(id).then(res =>
            setToast("Test message sent sucessfully", ToasterType.SUCCESS)
        ).catch(err =>
            setToast("Sending test message faild", ToasterType.DANGER)
        )
    }
    const changePhoneNumber = (id: string, value: any) => {
        const changeedData = data.map(x => x.Id === id ? { ...x, PhoneNumber: value.label, PhoneNumberId: value.id, Status: false } : x)
        setData(changeedData)
    }

    const changeTeam = (id: string, value: any) => {
        const changeedData = data.map(x => x.Id === id ? { ...x, TeamName: value.label, TeamGuid: value.id, ChannelName: "", ChannelId: "" } : x)
        setData(changeedData)
    }

    const changeChannel = (id: string, value: any) => {
        const changeedData = data.map(x => x.Id === id ? { ...x, ChannelName: value.label, ChannelId: value.id } : x)
        setData(changeedData)
    }

    return (
        <>
            {
                data?.length === 0 ?
                    <div className='d-flex w-p-100 flex-direction h-p-90 justify-center'>
                        <div className='d-flex align-center justify-center flex-direction'>
                            <span className="mx-auto my-2">
                                <IntegrationGridEmptyIcon />
                            </span>
                            <span className="h4-regular color-integration-card-title mx-auto my-1">There is no integration yet.</span>
                        </div>
                    </div>
                    :
                    <div className='d-flex w-p-100 flex-direction h-p-85 o-y-scroll'>
                        {
                            data?.map(x =>
                                <div className='d-flex justify-between align-center h-10 bb-primary-divider-2'>
                                    <div className='w-p-20  h4-regular ml-3'>
                                        {x.isEdit ? <Autocomplete
                                            size="small"
                                            disableClearable
                                            options={teamOptions}
                                            value={x.TeamName}
                                            onChange={(event: any, newValue: any) => { changeTeam(x.Id, newValue) }}
                                            className="m-auto autocomplete-standard w-p-95"
                                            renderInput={(params) => <TextField {...params} variant="standard" label="Select Team" />}
                                        />
                                            : <div className='w-break'>{x.TeamName}</div>
                                        }
                                    </div>
                                    <div className='w-p-20  h4-regular'>
                                        {x.isEdit ? <Autocomplete
                                            size="small"
                                            disableClearable
                                            options={channelOptions}
                                            value={x.ChannelName}
                                            onChange={(event: any, newValue: any) => { changeChannel(x.Id, newValue) }}
                                            className="m-auto autocomplete-standard w-p-95"
                                            renderInput={(params) => <TextField {...params} variant="standard" label="Select Channel" />}
                                        />
                                            : <div className='w-break'>{x.ChannelName}</div>
                                        }
                                    </div>
                                    <div className='w-p-5 d-flex  justify-center'>
                                        <IntegrationBlueIcon />
                                    </div>
                                    <div className='w-p-20 h4-regular'>
                                        <Autocomplete
                                            size="small"
                                            disableClearable
                                            options={phoneNumberOptions}
                                            value={x.PhoneNumber}
                                            onChange={(event: any, newValue: any) => {
                                                changePhoneNumber(x.Id, newValue)
                                            }}
                                            className="m-auto autocomplete-standard w-p-95"
                                            renderInput={(params) => <TextField {...params} variant="standard" label="Select Phone Number" />}
                                        />
                                    </div>
                                    <div className='w-p-30 h4-regular d-flex mx-auto justify-around align-center'>
                                        {x.Status ?
                                            <div className='m-auto  br-1 color-secondary p-1 bg-color-primary-success'>
                                                Connected
                                            </div>
                                            : <ButtonComponent Variant={!!x.PhoneNumber ? "primary-btn-small" : "disabled-btn-small"} ClassName="m-auto my-1" ButtonLabel={buttonLabels.LINK_PHONENMBER} OnClick={() => onClickLinkChannel(x)} />
                                        }
                                        <ButtonComponent Variant={x.PhoneNumber ? "secondary-btn-small" : "disabled-btn-small"} ClassName=" my-1" ButtonLabel={buttonLabels.TEST_INTEGRATION} OnClick={() => onClickTestIntegration(x.ChannelId)} />
                                    </div>
                                    <div className='w-p-5 d-flex justify-center'>
                                        <span className='m-auto c-pointer' onClick={() => onClickDelete(x.ChannelId)}>
                                            <DeleteChatIcon width={20} height={20} />
                                        </span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
            }
        </>
    )
}

export default IntegrateChannels;